import useSearchParams from "hooks/useSearchParams";
import { Container } from "layouts";
import PaddingX from "layouts/PaddingX";
import { BsExclamationCircleFill } from "react-icons/bs";
import { Link } from "react-router-dom";
// import useAuthStore from "store/useAuthStore";
import { motion } from "framer-motion";

const SubscriptionErrorResponse = () => {
	const { getParam } = useSearchParams();
	const paymentMethod = getParam("payment_method");
	const error = getParam("error");
	const retryUrl = getParam("retryUrl");

	return (
		<Container>
			<PaddingX>
				<motion.div
					className="mt-10 lg:mt-24 max-w-md mx-auto bg-white rounded-lg p-6"
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.6 }}
				>
					<div className="flex flex-col justify-center items-center">
						<motion.div
							className="flex justify-center items-center mb-4"
							initial={{ scale: 0.8 }}
							animate={{ scale: 1 }}
							transition={{ duration: 0.5, delay: 0.2 }}
						>
							<div className="bg-red-50 p-4 rounded-full">
								<BsExclamationCircleFill
									size={80}
									className="text-red-500"
								/>
							</div>
						</motion.div>

						<motion.div
							className="flex flex-col items-center gap-3 text-center w-full"
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							transition={{ duration: 0.5, delay: 0.4 }}
						>
							<h1 className="text-2xl font-bold text-gray-700">
								Subscription Failed
							</h1>
							<p className="text-gray-600 mb-2">
								Your <span className="font-medium">{paymentMethod}</span>{" "}
								payment could not be processed
							</p>

							{error && (
								<div className="bg-red-50 p-3 rounded-md w-full">
									<p className="text-red-700 text-sm">{error}</p>
								</div>
							)}

							<div className="my-5 pt-5 border-t border-gray-200 w-full text-center">
								<p className="text-gray-600 mb-4">
									If money was deducted from your account, please contact
									<Link
										className="font-medium text-blue-600 hover:text-blue-800 ml-1"
										to="/support"
									>
										our support team
									</Link>
								</p>

								<div className="flex flex-col sm:flex-row gap-3 justify-center mt-2">
									<motion.div
										whileHover={{ scale: 1.03 }}
										transition={{ duration: 0.2 }}
									>
										<Link
											to="/"
											className="px-4 py-2 bg-gray-100 text-gray-700 font-medium rounded-md transition-all hover:bg-gray-200 w-full sm:w-auto inline-block"
										>
											Back to home
										</Link>
									</motion.div>
									<motion.div
										whileHover={{ scale: 1.03 }}
										transition={{ duration: 0.2 }}
									>
										<Link
											to={retryUrl}
											className="px-4 py-2 bg-akgreener text-white font-medium rounded-md transition-all hover:bg-akgreen w-full sm:w-auto inline-block"
										>
											Retry payment
										</Link>
									</motion.div>
								</div>
							</div>
						</motion.div>
					</div>
				</motion.div>
			</PaddingX>
		</Container>
	);
};

export default SubscriptionErrorResponse;
